import { useEffect } from 'react';
//=========== css ================
import "aos/dist/aos.css";
import "./assets/css/style.css";
import "./assets/css/faq.css";
import "./assets/css/roadMap.css";
import "./assets/css/features.css";
import "./assets/css/team.css";
// =========== components ===================
import Home from "./container/Home"
import Footer from "./layout/Footer/Footer"
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AOS from "aos";
// ===========================================
//  ============= Logo image =============
import mainLogo from "./assets/images/others/logo_white_trans.png"


function App() {
  // initialized  Aos and check web loader
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1200,
      // offset: 150,
    });
    setTimeout(() => {
      document.querySelector('.loader-wrapper').classList.add('d-none')

    },650);
    console.clear();
  }, [])

  return (
    <>
      <Home />
      <Footer />
      <Loader />
      <GoToTop />
    </>
  );
}


// Website Loader
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="fixed-loading-wrapper">
        <div className="loader-wrapp">
          <div className="loader-logo">
            {/* ========== Loader Logo ================ */}
            <img src={mainLogo} alt="WeStream" />
          </div>
          <div className="loader"></div>
        </div>
      </div>
    </div>
  )
};

// Go To Top
const GoToTop = () => {
  useEffect(() => {
    window.onscroll = function () {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
      let btn = document.getElementById('scrollToTop');
      if (btn) {
        if (pageOffset > 450) {
          btn.classList.add('show-top')
        } else {
          btn.classList.remove('show-top')
        }
      }
    }
  }, []);
  // 
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  return (
    <div onClick={goToTop} className="go-to-top" id="scrollToTop">
      <ArrowUpwardIcon />
    </div>
  )
}

export default App;
